import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EParamTypesExtraInfo = {
	siteAccessAvailability: 'Asset Site Access Availability',
	powerSupplyAvailabilityStatus: 'Power Supply Availability Status',
	siteAvailabilityStatus: 'Asset Site Availability Status',
	backhaulA11yStatus: 'Backhaul Accessibility Status',
	specialImplementationExistence: 'Special Implementation Issues Exist',
} as const;

export type TParamTypesExtraInfo = TValueOfStringRecord<typeof EParamTypesExtraInfo>
